/* Mobile full-screen product discovery mode.
   Progressive enhancement only: the collection grid remains the default and
   can be restored instantly with the close button. */
(function () {
  'use strict';

  var MOBILE_QUERY = '(max-width: 749px)';
  var activeMode = 'grid';
  var itemObserver = null;
  var mutationObserver = null;
  var closeButton = null;
  var previousActiveElement = null;

  function getGrid() {
    return document.getElementById('product-grid');
  }

  function getSwitch() {
    return document.querySelector('[data-mobile-collection-mode]');
  }

  function getGallery(item) {
    if (item._mobileSwipeGallery) return item._mobileSwipeGallery;
    var source = item.querySelector('.mobile-swipe-gallery-data');
    try {
      item._mobileSwipeGallery = source ? JSON.parse(source.textContent).filter(function (image) {
        return image && image.src;
      }) : [];
    } catch (error) {
      item._mobileSwipeGallery = [];
    }
    return item._mobileSwipeGallery;
  }

  function updateGallery(item, requestedIndex) {
    var gallery = getGallery(item);
    if (!gallery.length) return;

    var index = (requestedIndex + gallery.length) % gallery.length;
    var image = item.querySelector('.mobile-swipe-gallery-image');
    var counter = item.querySelector('.mobile-swipe-image-count');
    if (!image) return;

    item.dataset.mobileSwipeImageIndex = String(index);
    if (image.getAttribute('src') !== gallery[index].src) {
      image.classList.remove('is-ready');
      image.onload = function () { image.classList.add('is-ready'); };
      image.src = gallery[index].src;
      image.alt = gallery[index].alt || '';
      if (image.complete) image.classList.add('is-ready');
    }

    if (counter) counter.textContent = String(index + 1) + ' / ' + String(gallery.length);
    item.querySelectorAll('.mobile-swipe-image-dot').forEach(function (dot, dotIndex) {
      dot.classList.toggle('is-active', dotIndex === index);
    });
  }

  function changeActiveImage(direction) {
    var grid = getGrid();
    if (!grid) return;
    var item = grid.querySelector('.grid__item.is-mobile-swipe-active') || grid.querySelector(':scope > .grid__item');
    if (!item) return;
    updateGallery(item, parseInt(item.dataset.mobileSwipeImageIndex || '0', 10) + direction);
  }

  function createCloseButton() {
    if (closeButton && document.body.contains(closeButton)) return closeButton;
    closeButton = document.createElement('button');
    closeButton.type = 'button';
    closeButton.className = 'mobile-swipe-close';
    closeButton.setAttribute('aria-label', 'Close swipe view');
    closeButton.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>';
    closeButton.addEventListener('click', function () { setMode('grid'); });
    document.body.appendChild(closeButton);
    return closeButton;
  }

  function addSwipeDecorations(grid) {
    var items = Array.prototype.slice.call(grid.querySelectorAll(':scope > .grid__item'));
    var total = items.length;

    items.forEach(function (item, index) {
      var productLink = item.querySelector('.card > .card__content .card__heading a') || item.querySelector('.card__heading a');
      var gallery = getGallery(item);

      item.querySelectorAll('.mobile-swipe-product-link').forEach(function (node) { node.remove(); });

      if (!item.querySelector('.mobile-swipe-gallery-image')) {
        var galleryImage = document.createElement('img');
        galleryImage.className = 'mobile-swipe-gallery-image';
        galleryImage.decoding = 'async';
        item.appendChild(galleryImage);
      }

      if (!item.querySelector('.mobile-swipe-position')) {
        var position = document.createElement('span');
        position.className = 'mobile-swipe-position';
        position.setAttribute('aria-hidden', 'true');
        item.appendChild(position);
      }
      item.querySelector('.mobile-swipe-position').textContent = String(index + 1).padStart(2, '0') + ' / ' + String(total).padStart(2, '0');

      if (gallery.length > 1 && !item.querySelector('.mobile-swipe-image-nav')) {
        var nav = document.createElement('div');
        nav.className = 'mobile-swipe-image-nav';
        nav.innerHTML = '<button type="button" class="mobile-swipe-image-nav__button mobile-swipe-image-nav__button--prev" aria-label="Previous product image"><svg viewBox="0 0 24 24"><path d="m14 6-6 6 6 6"/></svg></button><button type="button" class="mobile-swipe-image-nav__button mobile-swipe-image-nav__button--next" aria-label="Next product image"><svg viewBox="0 0 24 24"><path d="m10 6 6 6-6 6"/></svg></button>';
        nav.querySelector('.mobile-swipe-image-nav__button--prev').addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          updateGallery(item, parseInt(item.dataset.mobileSwipeImageIndex || '0', 10) - 1);
        });
        nav.querySelector('.mobile-swipe-image-nav__button--next').addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          updateGallery(item, parseInt(item.dataset.mobileSwipeImageIndex || '0', 10) + 1);
        });
        item.appendChild(nav);
      }

      if (gallery.length > 1 && !item.querySelector('.mobile-swipe-image-status')) {
        var status = document.createElement('div');
        status.className = 'mobile-swipe-image-status';
        status.setAttribute('aria-hidden', 'true');
        status.innerHTML = '<span class="mobile-swipe-image-count">1 / ' + gallery.length + '</span><span class="mobile-swipe-image-dots"></span>';
        var dots = status.querySelector('.mobile-swipe-image-dots');
        gallery.forEach(function (_, dotIndex) {
          var dot = document.createElement('span');
          dot.className = 'mobile-swipe-image-dot' + (dotIndex === 0 ? ' is-active' : '');
          dots.appendChild(dot);
        });
        item.appendChild(status);
      }

      var content = item.querySelector('.card > .card__content');
      if (content && productLink && !content.querySelector('.mobile-swipe-view-product')) {
        var viewLink = document.createElement('a');
        viewLink.className = 'mobile-swipe-view-product';
        viewLink.href = productLink.href;
        viewLink.innerHTML = 'View product <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
        content.appendChild(viewLink);
      }

      if (!item.querySelector('.mobile-swipe-hint')) {
        var hint = document.createElement('span');
        hint.className = 'mobile-swipe-hint';
        hint.setAttribute('aria-hidden', 'true');
        hint.innerHTML = '<svg viewBox="0 0 24 24"><path d="m7 14 5-5 5 5"/></svg>';
        item.appendChild(hint);
      }

      item.querySelectorAll('.card__media img').forEach(function (image) {
        if (!image.dataset.mobileSwipeSizes) image.dataset.mobileSwipeSizes = image.getAttribute('sizes') || '';
        image.setAttribute('sizes', '100vw');
      });
    });

    return items;
  }

  function removeSwipeDecorations(grid) {
    grid.querySelectorAll('.mobile-swipe-gallery-image, .mobile-swipe-image-nav, .mobile-swipe-image-status, .mobile-swipe-position, .mobile-swipe-view-product, .mobile-swipe-hint').forEach(function (node) {
      node.remove();
    });
    grid.querySelectorAll('.grid__item').forEach(function (item) {
      item.classList.remove('is-mobile-swipe-active');
      delete item.dataset.mobileSwipeImageIndex;
    });
    grid.querySelectorAll('.card__media img[data-mobile-swipe-sizes]').forEach(function (image) {
      if (image.dataset.mobileSwipeSizes) image.setAttribute('sizes', image.dataset.mobileSwipeSizes);
      else image.removeAttribute('sizes');
      delete image.dataset.mobileSwipeSizes;
    });
  }

  function observeItems(grid, items) {
    if (itemObserver) itemObserver.disconnect();
    itemObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var isActive = entry.isIntersecting && entry.intersectionRatio >= 0.6;
        entry.target.classList.toggle('is-mobile-swipe-active', isActive);
        if (isActive) updateGallery(entry.target, parseInt(entry.target.dataset.mobileSwipeImageIndex || '0', 10));
      });
    }, { root: grid, threshold: [0.6] });
    items.forEach(function (item) { itemObserver.observe(item); });
  }

  function updateButtons(mode) {
    var switcher = getSwitch();
    if (!switcher) return;
    switcher.querySelectorAll('[data-mobile-collection-mode-button]').forEach(function (button) {
      var isActive = button.dataset.mobileCollectionModeButton === mode;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function setMode(mode) {
    var grid = getGrid();
    if (!grid) return;
    var isMobile = window.matchMedia(MOBILE_QUERY).matches;
    activeMode = mode === 'swipe' && isMobile ? 'swipe' : 'grid';
    updateButtons(activeMode);

    if (activeMode === 'swipe') {
      previousActiveElement = document.activeElement;
      grid.classList.add('mobile-collection-swipe');
      document.documentElement.classList.add('mobile-swipe-mode');
      grid.setAttribute('tabindex', '0');
      grid.setAttribute('role', 'dialog');
      grid.setAttribute('aria-modal', 'true');
      grid.setAttribute('aria-label', 'Full-screen product browser. Swipe vertically for the next product.');
      var items = addSwipeDecorations(grid);
      observeItems(grid, items);
      var close = createCloseButton();
      close.hidden = false;
      window.requestAnimationFrame(function () { close.focus({ preventScroll: true }); });
    } else {
      if (itemObserver) itemObserver.disconnect();
      itemObserver = null;
      grid.classList.remove('mobile-collection-swipe');
      document.documentElement.classList.remove('mobile-swipe-mode');
      grid.removeAttribute('tabindex');
      grid.removeAttribute('role');
      grid.removeAttribute('aria-modal');
      grid.removeAttribute('aria-label');
      removeSwipeDecorations(grid);
      if (closeButton) closeButton.hidden = true;
      if (previousActiveElement && document.body.contains(previousActiveElement)) previousActiveElement.focus({ preventScroll: true });
      previousActiveElement = null;
    }
  }

  function bind() {
    var switcher = getSwitch();
    var grid = getGrid();
    if (!switcher || !grid || switcher.dataset.mobileSwipeBound === '1') return;
    switcher.dataset.mobileSwipeBound = '1';

    switcher.addEventListener('click', function (event) {
      var button = event.target.closest('[data-mobile-collection-mode-button]');
      if (!button) return;
      setMode(button.dataset.mobileCollectionModeButton);
    });

    grid.addEventListener('keydown', function (event) {
      if (activeMode !== 'swipe') return;
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        grid.scrollBy({ top: event.key === 'ArrowDown' ? grid.clientHeight : -grid.clientHeight, behavior: 'smooth' });
      } else if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault();
        changeActiveImage(event.key === 'ArrowRight' ? 1 : -1);
      }
    });

    if (!mutationObserver) {
      mutationObserver = new MutationObserver(function () {
        var currentGrid = getGrid();
        if (activeMode === 'swipe' && currentGrid && !currentGrid.classList.contains('mobile-collection-swipe')) setMode('swipe');
      });
      mutationObserver.observe(document.getElementById('ProductGridContainer') || document.body, { childList: true, subtree: true });
    }
  }

  function handleViewportChange() {
    if (!window.matchMedia(MOBILE_QUERY).matches && activeMode === 'swipe') setMode('grid');
  }

  document.addEventListener('keydown', function (event) {
    if (activeMode === 'swipe' && event.key === 'Escape') setMode('grid');
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
  else bind();
  document.addEventListener('shopify:section:load', bind);
  window.addEventListener('resize', handleViewportChange, { passive: true });
})();
